<script>
import { filterTasks } from '@/modules/task/filters/planningFilter'
import moment from 'moment-timezone'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'

export default {
  name: 'TaskFilters',
  props: ['date'],
  data () {
    return {
      searchText: '',
      field: '*',
      debounce: null
    }
  },
  created () {
    this.debounce = this.createSearchInputDebounce()
    this.searchTaskFromCalendar()
  },
  methods: {
    searchTasks () {
      if (this.field.length) {
        this.clearSearchingRelatedData()

        this.$parent.showAllSearchResults = false
        const loadingDate = moment(this.date).startOf('month').format('YYYY-MM-DD')
        const unloadingDate = moment(this.date).endOf('month').format('YYYY-MM-DD')

        if (this.searchText.length > 1) {
          this.debounce(() => {
            this.$parent.refreshing = true
            filterTasks(this.searchText, loadingDate, unloadingDate, this.field).then(tasks => {
              this.$parent.tasks = tasks
              this.$parent.foundTasksCount = tasks.length
              this.$parent.visibleTasksCount = tasks.length > 10 ? 10 : tasks.length
              this.$parent.searchFinished = true
              this.$parent.refreshing = false
            })
          })
        }
      } else {
        emitter.emit(eventKinds.planningSearchClosed)
      }
    },

    searchTaskFromCalendar () {
      if (this.$route.params?.vrid && this.$route.params?.date) {
        this.searchText = this.$route.params.vrid
        this.field = 'numer_Przejazdu'
        this.searchTasks()
      }
    },

    createSearchInputDebounce () {
      let timeout = null

      return function (fnc, delayInMs) {
        clearTimeout(timeout)

        timeout = setTimeout(() => {
          fnc()
        }, delayInMs || 1500)
      }
    },

    clearSearchingRelatedData () {
      this.$parent.tasks = []
      this.$parent.foundTasksCount = 0
      this.$parent.visibleTaskscount = 0
      this.$parent.searchFinished = false
    }
  }
}
</script>

<template>
  <input v-model="searchText" type="search" class="form-control search-input" @input="searchTasks">
  <select class="form-select field-selection" v-model="field" required @change="searchTasks">
    <option value="">-- Pokaż wszystkie zlecenia --</option>
    <option value="*">Wszystkie opcje szukania</option>
    <option value="numer_Przejazdu">Numer VRID</option>
    <option value="trasa">Trasa</option>
    <option value="nazwa_Firmy">Nazwa firmy</option>
    <option value="auto.plateNumber">Ciągnik</option>
    <option value="semitrailer.plateNumber">Naczepa</option>
    <option value="kierowcy.*.firstName">Imię kierowcy</option>
    <option value="kierowcy.*.surname">Nazwisko kierowcy</option>
    <option value="waluta">Waluta</option>
    <option value="stawka">Stawka</option>
    <option value="description1">Opis 1</option>
    <option value="description1">Opis 2</option>
    <option value="description1">Opis 3</option>
    <option value="stoppages.*.acronym">Postoje</option>
  </select>
</template>

<style scoped>
.field-selection {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.search-input {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
</style>
